import styles from "./strava-cta-overlay.module.css";

interface StravaCtaOverlayProps {
  onCreateAccount: () => void;
  onChangeTemplate?: () => void;
}

/**
 * Floating CTA overlay that appears over the Strava preview.
 * Displays a prominent "Create Your Poster" button with Strava branding.
 */
export const StravaCtaOverlay = ({
  onCreateAccount,
  onChangeTemplate,
}: StravaCtaOverlayProps) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <h2 className={styles.title}>Love what you see?</h2>
        <p className={styles.subtitle}>
          Create a free account to customize and order your poster.
        </p>

        <button className={styles.ctaButton} onClick={onCreateAccount}>
          <span className={styles.ctaIcon}>
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              width="20"
              height="20"
            >
              <path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169" />
            </svg>
          </span>
          Create Your Poster
        </button>

        {onChangeTemplate && (
          <button className={styles.secondaryLink} onClick={onChangeTemplate}>
            Change Template
          </button>
        )}
      </div>
    </div>
  );
};
